export default __webpack_public_path__ + "static/media/01.b20e6701.jpg";